import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import { AdminLayout } from './components/layout/AdminLayout';
import { ProtectedRoute } from './components/routing/ProtectedRoute';
import { resolveOperationsForPath } from './auth/access';
import { LandingPage } from './pages/LandingPage';
import { LoginPage } from './pages/LoginPage';
import { AdminDashboard } from './pages/admin/AdminDashboard';
import {
  CertificacoesFormPage,
  CertificacoesListPage,
  ComprasMadeiraFormPage,
  ComprasMadeiraListPage,
  EstoqueMadeiraFormPage,
  EstoqueMadeiraListPage,
  FornecedoresFormPage,
  FornecedoresListPage,
  TratamentosMadeiraFormPage,
  TratamentosMadeiraListPage,
} from './pages/aquisicao';
import {
  ApontamentosProducaoFormPage,
  ApontamentosProducaoListPage,
  ConsumoMadeiraFormPage,
  ConsumoMadeiraListPage,
  FichasFormPage,
  FichasListPage,
  LotesMadeiraFormPage,
  LotesMadeiraListPage,
  MaquinasFormPage,
  MaquinasListPage,
  OrdensProducaoFormPage,
  OrdensProducaoListPage,
  ProdutosFormPage,
  ProdutosListPage,
  TiposMaquinaFormPage,
  TiposMaquinaListPage,
  ContagensDiariasListPage,
  ContagensDiariasFormPage,
  DiaTrabalhoListPage,
  DiaTrabalhoFormPage,
  DiaTrabalhoReportPage,
} from './pages/producao';
import { UnidadesMedidaFormPage, UnidadesMedidaListPage } from './pages/aquisicao';
import {
  DefeitosCatalogoFormPage,
  DefeitosCatalogoListPage,
  DefeitosFormPage,
  DefeitosListPage,
  InspecoesFormPage,
  InspecoesListPage,
  RetrabalhosFormPage,
  RetrabalhosListPage,
} from './pages/qualidade';
import {
  ArmazensFormPage,
  ArmazensListPage,
  ClientesFormPage,
  ClientesListPage,
  EstoqueProdutosFormPage,
  EstoqueProdutosListPage,
  MovimentacoesProdutosFormPage,
  MovimentacoesProdutosListPage,
  PedidosExpedicaoFormPage,
  PedidosExpedicaoListPage,
  PlanejamentoCargasFormPage,
  PlanejamentoCargasListPage,
  TiposProdutoFormPage,
  TiposProdutoListPage,
} from './pages/estoque';
import { ExpedicoesFormPage } from './pages/estoque/ExpedicoesFormPage';
import { ExpedicoesListPage } from './pages/estoque/ExpedicoesListPage';
import {
  HistoricoManutencaoFormPage,
  HistoricoManutencaoListPage,
  OrdensManutencaoFormPage,
  OrdensManutencaoListPage,
} from './pages/manutencao';
import {
  KpisFormPage,
  KpisListPage,
  MetricasKpiFormPage,
  MetricasKpiListPage,
  RelatoriosProdutividadeFormPage,
  RelatoriosProdutividadeListPage,
  ConsolidacaoDiariaPage,
} from './pages/indicadores';
import {
  CidadesFormPage,
  CidadesListPage,
  EnderecosFormPage,
  EnderecosListPage,
  EntidadesFormPage,
  EntidadesListPage,
  OperadoresFormPage,
  OperadoresListPage,
  ProdutividadeOperadorFormPage,
  ProdutividadeOperadorListPage,
  TreinamentosFormPage,
  TreinamentosListPage,
  UfsFormPage,
  UfsListPage,
} from './pages/pessoas';
import {
  VeiculosFormPage,
  VeiculosListPage,
  AcoplamentosFormPage,
  AcoplamentosListPage,
  OrdensServicoFormPage,
  OrdensServicoListPage,
  OrdensTransporteFormPage,
  OrdensTransporteListPage,
  ChecklistTemplatesFormPage,
  ChecklistTemplatesListPage,
  ChecklistsFormPage,
  ChecklistsListPage,
} from './pages/logistica';
import {
  EtiquetasFormPage,
  EtiquetasListPage,
  EtiquetasModelosListPage,
  EtiquetasModelosFormPage,
} from './pages/etiquetas';
import {
  InventariosFormPage,
  InventariosListPage,
} from './pages/inventario';
import {
  ProdutosImportPage,
  OrdensProducaoImportPage,
} from './pages/imports';
import { NotFoundPage } from './pages/error/NotFoundPage';
import { ForbiddenPage } from './pages/error/ForbiddenPage';
import { InternalServerErrorPage } from './pages/error/InternalServerErrorPage';
import { MensageriaPage } from './pages/perfil';

interface AdminRouteConfig {
  path: string;
  Component: React.FC;
  operations?: string[];
  permissions?: string[];
}

const adminResourceRoutes: AdminRouteConfig[] = [
  { path: '/admin/aquisicao/fornecedores', Component: FornecedoresListPage },
  { path: '/admin/aquisicao/fornecedores/novo', Component: FornecedoresFormPage },
  { path: '/admin/aquisicao/fornecedores/:id', Component: FornecedoresFormPage },
  { path: '/admin/aquisicao/certificacoes', Component: CertificacoesListPage },
  { path: '/admin/aquisicao/certificacoes/novo', Component: CertificacoesFormPage },
  { path: '/admin/aquisicao/certificacoes/editar', Component: CertificacoesFormPage },
  { path: '/admin/aquisicao/certificacoes/:id', Component: CertificacoesFormPage },
  { path: '/admin/aquisicao/compras-madeira', Component: ComprasMadeiraListPage },
  { path: '/admin/aquisicao/compras-madeira/novo', Component: ComprasMadeiraFormPage },
  { path: '/admin/aquisicao/compras-madeira/:id', Component: ComprasMadeiraFormPage },
  { path: '/admin/aquisicao/tratamentos-madeira', Component: TratamentosMadeiraListPage },
  { path: '/admin/aquisicao/tratamentos-madeira/novo', Component: TratamentosMadeiraFormPage },
  { path: '/admin/aquisicao/tratamentos-madeira/:id', Component: TratamentosMadeiraFormPage },
  { path: '/admin/aquisicao/estoque-madeira', Component: EstoqueMadeiraListPage },
  { path: '/admin/aquisicao/estoque-madeira/novo', Component: EstoqueMadeiraFormPage },
  { path: '/admin/aquisicao/estoque-madeira/:id', Component: EstoqueMadeiraFormPage },
  { path: '/admin/parametros/unidades-medida', Component: UnidadesMedidaListPage },
  { path: '/admin/parametros/unidades-medida/novo', Component: UnidadesMedidaFormPage },
  { path: '/admin/parametros/unidades-medida/:id', Component: UnidadesMedidaFormPage },
  { path: '/admin/cadastro/produtos', Component: ProdutosListPage },
  { path: '/admin/cadastro/produtos/novo', Component: ProdutosFormPage },
  { path: '/admin/cadastro/produtos/:id', Component: ProdutosFormPage },
  { path: '/admin/producao/lotes-madeira', Component: LotesMadeiraListPage },
  { path: '/admin/producao/lotes-madeira/novo', Component: LotesMadeiraFormPage },
  { path: '/admin/producao/lotes-madeira/:id', Component: LotesMadeiraFormPage },
  { path: '/admin/producao/tipos-maquina', Component: TiposMaquinaListPage },
  { path: '/admin/producao/tipos-maquina/novo', Component: TiposMaquinaFormPage },
  { path: '/admin/producao/tipos-maquina/:id', Component: TiposMaquinaFormPage },
  { path: '/admin/producao/maquinas', Component: MaquinasListPage },
  { path: '/admin/producao/maquinas/novo', Component: MaquinasFormPage },
  { path: '/admin/producao/maquinas/:id', Component: MaquinasFormPage },
  { path: '/admin/producao/ordens-producao', Component: OrdensProducaoListPage },
  { path: '/admin/producao/ordens-producao/novo', Component: OrdensProducaoFormPage },
  { path: '/admin/producao/ordens-producao/:id', Component: OrdensProducaoFormPage },
  { path: '/admin/producao/apontamentos-producao', Component: ApontamentosProducaoListPage },
  { path: '/admin/producao/apontamentos-producao/novo', Component: ApontamentosProducaoFormPage },
  { path: '/admin/producao/apontamentos-producao/:id', Component: ApontamentosProducaoFormPage },
  { path: '/admin/producao/consumo-madeira', Component: ConsumoMadeiraListPage },
  { path: '/admin/producao/consumo-madeira/novo', Component: ConsumoMadeiraFormPage },
  { path: '/admin/producao/consumo-madeira/:id', Component: ConsumoMadeiraFormPage },
  { path: '/admin/qualidade/inspecoes', Component: InspecoesListPage },
  { path: '/admin/qualidade/inspecoes/novo', Component: InspecoesFormPage },
  { path: '/admin/qualidade/inspecoes/:id', Component: InspecoesFormPage },
  { path: '/admin/qualidade/defeitos', Component: DefeitosListPage },
  { path: '/admin/qualidade/defeitos/novo', Component: DefeitosFormPage },
  { path: '/admin/qualidade/defeitos/:id', Component: DefeitosFormPage },
  { path: '/admin/parametros/defeitos-catalogo', Component: DefeitosCatalogoListPage },
  { path: '/admin/parametros/defeitos-catalogo/novo', Component: DefeitosCatalogoFormPage },
  { path: '/admin/parametros/defeitos-catalogo/:id', Component: DefeitosCatalogoFormPage },
  { path: '/admin/qualidade/retrabalhos', Component: RetrabalhosListPage },
  { path: '/admin/qualidade/retrabalhos/novo', Component: RetrabalhosFormPage },
  { path: '/admin/qualidade/retrabalhos/:id', Component: RetrabalhosFormPage },
  { path: '/admin/estoque/clientes', Component: ClientesListPage },
  { path: '/admin/estoque/clientes/novo', Component: ClientesFormPage },
  { path: '/admin/estoque/clientes/:id', Component: ClientesFormPage },
  { path: '/admin/estoque/estoque-produtos', Component: EstoqueProdutosListPage },
  { path: '/admin/estoque/estoque-produtos/novo', Component: EstoqueProdutosFormPage },
  { path: '/admin/estoque/estoque-produtos/:id', Component: EstoqueProdutosFormPage },
  { path: '/admin/estoque/pedidos-expedicao', Component: PedidosExpedicaoListPage },
  { path: '/admin/estoque/pedidos-expedicao/novo', Component: PedidosExpedicaoFormPage },
  { path: '/admin/estoque/pedidos-expedicao/:id', Component: PedidosExpedicaoFormPage },
  { path: '/admin/estoque/expedicoes', Component: ExpedicoesListPage },
  { path: '/admin/estoque/expedicoes/novo', Component: ExpedicoesFormPage },
  { path: '/admin/estoque/expedicoes/:id', Component: ExpedicoesFormPage },
  { path: '/admin/estoque/planejamento-cargas', Component: PlanejamentoCargasListPage },
  { path: '/admin/estoque/planejamento-cargas/novo', Component: PlanejamentoCargasFormPage },
  { path: '/admin/estoque/planejamento-cargas/:id', Component: PlanejamentoCargasFormPage },
  { path: '/admin/estoque/tipos-produto', Component: TiposProdutoListPage },
  { path: '/admin/estoque/tipos-produto/novo', Component: TiposProdutoFormPage },
  { path: '/admin/estoque/tipos-produto/:id', Component: TiposProdutoFormPage },
  { path: '/admin/movimento/transferencias-estoque', Component: MovimentacoesProdutosListPage },
  { path: '/admin/movimento/transferencias-estoque/novo', Component: MovimentacoesProdutosFormPage },
  { path: '/admin/movimento/transferencias-estoque/:id', Component: MovimentacoesProdutosFormPage },
  { path: '/admin/parametros/armazens', Component: ArmazensListPage },
  { path: '/admin/parametros/armazens/novo', Component: ArmazensFormPage },
  { path: '/admin/parametros/armazens/:id', Component: ArmazensFormPage },
  { path: '/admin/manutencao/ordens-manutencao', Component: OrdensManutencaoListPage },
  { path: '/admin/manutencao/ordens-manutencao/novo', Component: OrdensManutencaoFormPage },
  { path: '/admin/manutencao/ordens-manutencao/:id', Component: OrdensManutencaoFormPage },
  { path: '/admin/manutencao/historico-manutencao', Component: HistoricoManutencaoListPage },
  { path: '/admin/manutencao/historico-manutencao/novo', Component: HistoricoManutencaoFormPage },
  { path: '/admin/manutencao/historico-manutencao/:id', Component: HistoricoManutencaoFormPage },
  { path: '/admin/indicadores/kpis', Component: KpisListPage },
  { path: '/admin/indicadores/kpis/novo', Component: KpisFormPage },
  { path: '/admin/indicadores/kpis/:id', Component: KpisFormPage },
  { path: '/admin/indicadores/metricas-kpi', Component: MetricasKpiListPage },
  { path: '/admin/indicadores/metricas-kpi/novo', Component: MetricasKpiFormPage },
  { path: '/admin/indicadores/metricas-kpi/:id', Component: MetricasKpiFormPage },
  { path: '/admin/indicadores/relatorios-produtividade', Component: RelatoriosProdutividadeListPage },
  { path: '/admin/indicadores/relatorios-produtividade/novo', Component: RelatoriosProdutividadeFormPage },
  { path: '/admin/indicadores/relatorios-produtividade/:id', Component: RelatoriosProdutividadeFormPage },
  { path: '/admin/indicadores/consolidacao-diaria', Component: ConsolidacaoDiariaPage },
  { path: '/admin/pessoas/operadores', Component: OperadoresListPage },
  { path: '/admin/pessoas/operadores/novo', Component: OperadoresFormPage },
  { path: '/admin/pessoas/operadores/:id', Component: OperadoresFormPage },
  { path: '/admin/pessoas/ufs', Component: UfsListPage },
  { path: '/admin/pessoas/ufs/novo', Component: UfsFormPage },
  { path: '/admin/pessoas/ufs/:id', Component: UfsFormPage },
  { path: '/admin/pessoas/cidades', Component: CidadesListPage },
  { path: '/admin/pessoas/cidades/novo', Component: CidadesFormPage },
  { path: '/admin/pessoas/cidades/:id', Component: CidadesFormPage },
  { path: '/admin/pessoas/entidades', Component: EntidadesListPage },
  { path: '/admin/pessoas/entidades/novo', Component: EntidadesFormPage },
  { path: '/admin/pessoas/entidades/:id', Component: EntidadesFormPage },
  { path: '/admin/pessoas/treinamentos', Component: TreinamentosListPage },
  { path: '/admin/pessoas/treinamentos/novo', Component: TreinamentosFormPage },
  { path: '/admin/pessoas/treinamentos/:id', Component: TreinamentosFormPage },
  { path: '/admin/pessoas/produtividade-operador', Component: ProdutividadeOperadorListPage },
  { path: '/admin/pessoas/produtividade-operador/novo', Component: ProdutividadeOperadorFormPage },
  { path: '/admin/pessoas/produtividade-operador/:id', Component: ProdutividadeOperadorFormPage },
  { path: '/admin/pessoas/enderecos', Component: EnderecosListPage },
  { path: '/admin/pessoas/enderecos/novo', Component: EnderecosFormPage },
  { path: '/admin/pessoas/enderecos/:id', Component: EnderecosFormPage },
  { path: '/admin/perfil/mensagens', Component: MensageriaPage },
  // Logística
  { path: '/admin/logistica/veiculos', Component: VeiculosListPage },
  { path: '/admin/logistica/veiculos/novo', Component: VeiculosFormPage },
  { path: '/admin/logistica/veiculos/:id', Component: VeiculosFormPage },
  { path: '/admin/logistica/acoplamentos', Component: AcoplamentosListPage },
  { path: '/admin/logistica/acoplamentos/novo', Component: AcoplamentosFormPage },
  { path: '/admin/logistica/acoplamentos/:id', Component: AcoplamentosFormPage },
  { path: '/admin/logistica/ordens-servico', Component: OrdensServicoListPage },
  { path: '/admin/logistica/ordens-servico/novo', Component: OrdensServicoFormPage },
  { path: '/admin/logistica/ordens-servico/:id', Component: OrdensServicoFormPage },
  { path: '/admin/logistica/ordens-transporte', Component: OrdensTransporteListPage },
  { path: '/admin/logistica/ordens-transporte/novo', Component: OrdensTransporteFormPage },
  { path: '/admin/logistica/ordens-transporte/:id', Component: OrdensTransporteFormPage },
  { path: '/admin/logistica/checklist-templates', Component: ChecklistTemplatesListPage },
  { path: '/admin/logistica/checklist-templates/novo', Component: ChecklistTemplatesFormPage },
  { path: '/admin/logistica/checklist-templates/:id', Component: ChecklistTemplatesFormPage },
  { path: '/admin/logistica/checklists', Component: ChecklistsListPage },
  { path: '/admin/logistica/checklists/novo', Component: ChecklistsFormPage },
  { path: '/admin/logistica/checklists/:id', Component: ChecklistsFormPage },
  // Etiquetas (Produção)
  { path: '/admin/producao/etiquetas', Component: EtiquetasListPage },
  { path: '/admin/producao/etiquetas/novo', Component: EtiquetasFormPage },
  { path: '/admin/producao/etiquetas/:id', Component: EtiquetasFormPage },
  { path: '/admin/producao/fichas-tecnicas', Component: FichasListPage },
  { path: '/admin/producao/fichas-tecnicas/novo', Component: FichasFormPage },
  { path: '/admin/producao/fichas-tecnicas/:id', Component: FichasFormPage },
  { path: '/admin/producao/contagens-diarias', Component: ContagensDiariasListPage },
  { path: '/admin/producao/contagens-diarias/novo', Component: ContagensDiariasFormPage },
  { path: '/admin/producao/contagens-diarias/:id', Component: ContagensDiariasFormPage },
  { path: '/admin/producao/dias-trabalho', Component: DiaTrabalhoListPage },
  { path: '/admin/producao/dias-trabalho/novo', Component: DiaTrabalhoFormPage },
  { path: '/admin/producao/dias-trabalho/:id', Component: DiaTrabalhoFormPage },
  { path: '/admin/producao/dias-trabalho/:id/relatorio', Component: DiaTrabalhoReportPage },
  // Modelos de Etiquetas (Produção)
  { path: '/admin/producao/etiquetas-modelos', Component: EtiquetasModelosListPage },
  { path: '/admin/producao/etiquetas-modelos/novo', Component: EtiquetasModelosFormPage },
  { path: '/admin/producao/etiquetas-modelos/:id', Component: EtiquetasModelosFormPage },
  // Inventário (Estoque)
  { path: '/admin/estoque/inventarios', Component: InventariosListPage },
  { path: '/admin/estoque/inventarios/novo', Component: InventariosFormPage },
  { path: '/admin/estoque/inventarios/:id', Component: InventariosFormPage },
  // Importações
  { path: '/admin/imports/produtos', Component: ProdutosImportPage },
  { path: '/admin/imports/ordens-producao', Component: OrdensProducaoImportPage },
];

const adminRoutesWithAliases: AdminRouteConfig[] = (() => {
  const result: AdminRouteConfig[] = [];
  const seen = new Set<string>();

  adminResourceRoutes.forEach((route) => {
    if (!seen.has(route.path)) {
      result.push(route);
      seen.add(route.path);
    }

    if (route.path.endsWith('/novo')) {
      const editPath = route.path.replace(/\/novo$/, '/editar');
      if (!seen.has(editPath)) {
        result.push({ ...route, path: editPath });
        seen.add(editPath);
      }
    }
  });

  return result;
})();

const normalizeAdminPath = (path: string) => path.replace(/^\/admin\/?/, '');

const adminChildRoutes = adminRoutesWithAliases.map(({ path, Component, operations, permissions }) => {
  const normalizedPath = normalizeAdminPath(path);
  const resolvedOperations = operations ?? resolveOperationsForPath(path);

  return {
    path: normalizedPath,
    element: (
      <ProtectedRoute
        requiredOperations={resolvedOperations}
        requiredPermissions={permissions}
      />
    ),
    children: [{ index: true, element: <Component /> }],
  };
});

export const router = createBrowserRouter([
  {
    path: '/',
    element: <LandingPage />,
    errorElement: <InternalServerErrorPage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
    errorElement: <InternalServerErrorPage />,
  },
  {
    path: '/admin',
    element: <ProtectedRoute requiredOperations={resolveOperationsForPath('/admin')} />,
    errorElement: <InternalServerErrorPage />,
    children: [
      {
        element: <AdminLayout />,
        children: [
          { index: true, element: <AdminDashboard /> },
          ...adminChildRoutes,
          { path: '404', element: <NotFoundPage /> },
          { path: '*', element: <NotFoundPage /> },
        ],
      },
    ],
  },
  {
    path: '/404',
    element: <NotFoundPage />,
  },
  {
    path: '/forbidden',
    element: <ForbiddenPage />,
  },
  {
    path: '/error',
    element: <InternalServerErrorPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
]);
